//memes list constants
export const GET_MEMES_LIST_REQUEST = 'GET_MEMES_LIST_REQUEST'
export const GET_MEMES_LIST_SUCCESS = 'GET_MEMES_LIST_SUCCESS'
export const GET_MEMES_LIST_FAILURE = 'GET_MEMES_LIST_FAILURE'

export const DELETE_MEMES_LIST_REQUEST = 'DELETE_MEMES_LIST_REQUEST'
export const DELETE_MEMES_LIST_SUCCESS = 'DELETE_MEMES_LIST_SUCCESS'
export const DELETE_MEMES_LIST_FAILURE = 'DELETE_MEMES_LIST_FAILURE'


//single meme constants
export const GET_SINGLE_MEME_REQUEST = 'GET_SINGLE_MEME_REQUEST'
export const GET_SINGLE_MEME_SUCCESS = 'GET_SINGLE_MEME_SUCCESS'
export const GET_SINGLE_MEME_FAILURE = 'GET_SINGLE_MEME_FAILURE'

export const POST_SINGLE_MEME_REQUEST = 'POST_SINGLE_MEME_REQUEST'
export const POST_SINGLE_MEME_SUCCESS = 'POST_SINGLE_MEME_SUCCESS'
export const POST_SINGLE_MEME_FAILURE = 'POST_SINGLE_MEME_FAILURE'

export const UPDATE_SINGLE_MEME_REQUEST = 'UPDATE_SINGLE_MEME_REQUEST'
export const UPDATE_SINGLE_MEME_SUCCESS = 'UPDATE_SINGLE_MEME_SUCCESS'
export const UPDATE_SINGLE_MEME_FAILURE = 'UPDATE_SINGLE_MEME_FAILURE'

export const DELETE_SINGLE_MEME_REQUEST = 'DELETE_SINGLE_MEME_REQUEST'
export const DELETE_SINGLE_MEME_SUCCESS = 'DELETE_SINGLE_MEME_SUCCESS'
export const DELETE_SINGLE_MEME_FAILURE = 'DELETE_SINGLE_MEME_FAILURE'
